export const ADD_TO_CART = 'add_to_cart'
export const PRODUCT = 'product'
export const BUYBACK_DEVICE_SPECIFICATIONS = 'buyback_device_specifications'
export const SEARCH_TERM = 'search_term'
